import Page from "webPage/Page";
import CanvasImage from "CanvasImage";

Page.register('/equip-in-the-community', function(){
    //SIZE OF IMAGE NOT SIZE OF SCREEN

    let masksContent = {
        0: [
            {
                'url': '/images/png/masks/content/content-mask--mobile.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/content/content-mask--600.png',
                'vPos': 'top'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/content/content-mask.png',
                'vPos': 'top'
            }
        ]
    };

    let masksContent2 = {
        0: [
            {
                'url': '/images/png/masks/content/content-mask--mobile.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/content/content-mask-2--600.png',
                'vPos': 'top'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/content/content-mask-2.png',
                'vPos': 'top'
            }
        ]
    };


    let maskCourses = {
        0: [
            {
                'url': '/images/png/masks/equip-in-the-community/equality-network-mask.png',
                'vPos': 'top',
                'hPos': 'center'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/equip-in-the-community/equality-network-mask.png',
                'vPos': 'top',
                'hPos': 'center'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/equip-in-the-community/equality-network-mask.png',
                'vPos': 'top',
                'hPos': 'center'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/equip-in-the-community/equality-network-mask.png',
                'vPos': 'top',
                'hPos': 'center'
            }
        ]
    };

    new CanvasImage($('.content__img--discrimination'), masksContent);

    new CanvasImage($('.content__img--integration'), masksContent2);

    new CanvasImage($('.courses__background'), maskCourses);

});
